(function ($) {
	$.fn.nhraNewsNav = function(options) {
		// NOTE: Don't run logic below if nothing is in the dom
		if (!this.length) {
			return false;
		}

		// These are all the methods available for the plugin
		var methods = {};

		methods.newsItemNav = function($context) {

			var is_news =  $('body[class*="page-node-type-article"]');

			if ( is_news ) {

				var items = jQuery('ul.article-list').find('h3 a');
				var currentArticlePath = window.location.pathname;
				var itemsCount = items.length - 1;
				var prevButton = '';
				var nextButton = '';

				nextButton = '<li class="pager__item pager__item--next"><a href="' + items[0] + '" title="Go to next page" rel="next"><span aria-hidden="true">Next ›</span></a></li>';

				items.each(function (idx) {
					if (this.pathname == currentArticlePath) {

						// Check index, then create item button
						if( idx > 0 ){
							prevButton = '<li class="pager__item"><a href="' + items[idx - 1] + '" title="Go to previous page" rel="prev"><span aria-hidden="true">‹ Previous</span></a></li>';
						}

						// Check index, then create next item button
						if( idx < itemsCount ){
							nextButton = '<li class="pager__item pager__item--next"><a href="' + items[idx + 1] + '" title="Go to next page" rel="next"><span aria-hidden="true">Next ›</span></a></li>';
						}
						return (false);
					}
				});

				if($('nav.news.pager').length < 1) {
					$('.article-card.article-card--open').append('<nav class="news pager" role="navigation" aria-labelledby="pagination-heading"><h3 id="pagination-heading" class="visually-hidden">News Pagination</h3><ul class="pager__items">' + prevButton + '' + nextButton + '</ul></nav>');
				}
			}
		}

		// On load function
		methods.events = function($context) {
			methods.newsItemNav($context);
		}

		// Run once methods when jquery plugin is called
		methods.events(this);
	};

}(jQuery));
